var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"component filter-collection"},_vm._l((_vm.filterConditions),function(item){return _c('el-button',{key:item.text,attrs:{"type":item.type,"round":"","size":"mini"},on:{"click":function($event){return _vm.onFilterSearch(item)}}},[_vm._v(_vm._s(item.text))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }